import { StripMagCustomArgs } from "./Stipmag"

export const getCustomArgs = (ident: string) => {
  switch (ident) {
    case "STRIPMAG":
      return StripMagCustomArgs
    default:
      return null
  }
}
